/**
 * Ryan O'Dowd
 * 2024-03-01
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    adminSettingsWrapper: {
      backgroundColor: colors.primaryExtraLight,
    },
    adminOptionsInner: {
      flex: 1,
    },
  };
};

export default getStyles;
